export default "__VITE_ASSET__Da$Ke1jj__"